/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import FreeBreakfastOutlinedIcon from '@mui/icons-material/FreeBreakfastOutlined';
import MoreTimeOutlinedIcon from '@mui/icons-material/MoreTimeOutlined';
import TimerOffOutlinedIcon from '@mui/icons-material/TimerOffOutlined';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import { StatCardV2 } from '../../../components/v2';
import { REGRAS, formatInspetorDias } from './constants';

const ICONS = {
  EXTRA_DIARIA: <MoreTimeOutlinedIcon />,
  ALMOCO: <FreeBreakfastOutlinedIcon />,
  DIAS_CONSECUTIVOS: <TodayOutlinedIcon />,
  EXTRA_CICLO: <TimerOffOutlinedIcon />,
  SEM_JORNADA: <EventBusyOutlinedIcon />,
};

const KpiStrip = ({ kpis, loading, activeRegra, onSelect }) => (
  <Box
    sx={{
      display: 'grid',
      gap: 2,
      gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(5, minmax(0, 1fr))' },
    }}
  >
    {REGRAS.map((regra) => {
      const metric = kpis?.[regra.id] || { inspetores: 0, dias: null, horas: null };
      const active = activeRegra === regra.id;
      return (
        <Box key={regra.id}>
          <StatCardV2
            label={`${regra.short} · ${regra.label}`}
            value={metric.inspetores}
            caption={formatInspetorDias(metric.inspetores, metric.dias, metric.horas)}
            icon={ICONS[regra.id]}
            color={regra.statColor}
            loading={loading}
            active={active}
            activeLabel={active ? 'Filtrando a lista' : undefined}
            hint={regra.hint}
            onClick={() => onSelect(active ? null : regra.id)}
          />
        </Box>
      );
    })}
  </Box>
);

KpiStrip.propTypes = {
  kpis: PropTypes.object,
  loading: PropTypes.bool,
  activeRegra: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};

export default KpiStrip;
